module.exports = __webpack_public_path__ + "img/w49b.720ba5c0.jpg";